<template>
  <v-card class="detail-wrapper">
    <div v-bind:class="getMenuClass">
      <v-layout row wrap>
        <v-flex>
          <div class="wo-number-wrapper">
            <h3 class=" wo-number pt-1 pl-4">
              WO {{ task.workOrder.workOrderNumber }} - {{ task.taskNumber }}
              <div style="float:right; margin-left:5px;">
              <div v-if="task.flagged ==='ATTN'"><v-icon dark style="vertical-align: text-top;">mdi-alpha-a-circle</v-icon> </div>
              <div v-if="task.flagged ==='PON'"><v-icon dark style="vertical-align: text-top;">mdi-alpha-p-circle</v-icon></div>
              <div v-if="task.flagged ==='BOTH'"> <v-icon dark style="vertical-align: text-top;">mdi-alpha-a-circle</v-icon><v-icon  dark style="vertical-align: text-top;">mdi-alpha-p-circle</v-icon></div>
              </div>
            </h3>
            <div class="pl-4 pb-4" style="font-size: 14px;">{{ task.status }}</div>

          </div>
          <v-btn
            @click="clearTask"
            class="text-right close-details"
            height="40"
            width="40"
            icon
            dark
            small>
            <v-icon size="32">close</v-icon>
          </v-btn>
          <v-icon class="icon-separator" style="float: right;"></v-icon>
          <div class="details-actions-wrapper">
            <div class="details-action">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn
                    to="/work-order/task-manager/"
                    class="text-right"
                    height="40"
                    width="40"
                    small
                    icon
                    dark
                    v-on="on">
                    <v-icon>mdi-square-edit-outline</v-icon>
                  </v-btn>
                </template>
                <span>Edit Task</span>
              </v-tooltip>
            </div>
            <div v-if="!isDisabled" >
            <div class="details-action">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="toggleFlag"
                    class="text-right"
                    height="40"
                    width="40"
                    small
                    icon
                    dark
                    v-on="on">
                    <v-icon>flag</v-icon>
                  </v-btn>
                </template>
                <span>Flag Task</span>
              </v-tooltip>
            </div>
            <div class="details-action">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="archiveDialogForTask"
                    class="text-right"
                    height="40"
                    width="40"
                    small
                    icon
                    dark
                    v-on="on">
                    <v-icon>mdi-archive</v-icon>
                  </v-btn>
                </template>
                <span>Archive Task</span>
              </v-tooltip>
            </div>
            <div class="details-action">
              <v-tooltip top color="secondary">
                <template v-slot:activator="{ on }">
                  <v-btn
                    @click="toggleEdit"
                    class="text-right"
                    height="40"
                    width="40"
                    small
                    icon
                    dark
                    v-on="on">
                    <v-icon>mdi-calendar</v-icon>
                  </v-btn>
                </template>
                <span>Schedule Task</span>
              </v-tooltip>
            </div>
           </div>
          </div>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <div class="tab-bar">
        <v-tabs
          color="accent"
          v-model="tab"
          grow
          show-arrows
        >
          <v-tabs-slider></v-tabs-slider>
          <v-tab key="first" href="#overview">Overview</v-tab>
          <v-tab href="#documents" @click="loadDocuments(task.id)" >Documents</v-tab>
          <v-tab href="#images" @click="loadImages({ taskId: task.id, size: 'small' })">Images</v-tab>
          <v-tab href="#crews">Crews</v-tab>
          <v-tab v-if="this.userRole === 'Admin'" href="#changes" @click="loadChangeOrders(task.id)">Changes</v-tab>
          <v-tab v-if="this.userRole === 'Admin'" href="#billing">Billing</v-tab>
        </v-tabs>
      </div>
      <v-tabs-items v-model="tab">
        <v-tab-item value="overview">
          <overview></overview>
        </v-tab-item>
        <v-tab-item value="documents">
          <document-list></document-list>
        </v-tab-item>
        <v-tab-item value="images">
          <image-list></image-list>
        </v-tab-item>
        <v-tab-item value="crews">
          <v-col style="padding-top: 0;" cols="12">
            <template>
              <v-row justify="center">
                <v-dialog v-model="showAddDialog" persistent max-width="290">
                  <v-card>
                    <v-card-title class="headline pt-1 pr-1">
                      Add Crew To Task
                      <v-spacer></v-spacer>
                      <v-btn icon @click="showAddDialog = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-container>
                      <v-select
                        label="Crew Name / Number"
                        :items="crews"
                        v-model="crewSelected"
                        chips
                        hide-no-data
                        clearable
                        item-text="text"
                        item-value="value">
                      </v-select>
                    </v-container>
                    <v-card-actions>
                      <div class="flex-grow-1"></div>
                      <v-btn outlined color="accent" @click="addCrewToTask">Add</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>
            <v-simple-table>
              <template v-slot:default>
                <thead>
                <tr>
                  <th class="text-left">Crew Name / Number</th>
                  <th class="text-left crew-lead-name-header">Lead Name</th>
                  <th class="text-left crew-lead-phone-header">Lead Phone</th>
                  <th class="text-left crew-lead-email-header">Lead Email</th>
                  <th class="text-right">Action</th>
                 </tr>
                </thead>
                <tbody v-for="crew in crewSelected" :key="crew.name">
                <checklist-crew-details :crew="crew.value" ref="crew"></checklist-crew-details>
                <div></div>
                </tbody>
                <tfoot>
                <tr>
                  <td style="padding: 12px 0 0 0" class="text-right" colspan="6">
                    <div>
                      <v-btn :disabled="isDisabled"  @click="showAddDialog = true" depressed medium color="accent">Add Crew</v-btn>
                    </div>
                  </td>
                </tr>
                </tfoot>
              </template>
            </v-simple-table>
          </v-col>
        </v-tab-item>
        <v-tab-item value="changes">
          <change-order-list></change-order-list>
        </v-tab-item>
        <v-tab-item value="billing">
          billing
        </v-tab-item>
      </v-tabs-items>
    </div>
    <archive-task :showDialog="archiveTaskDialog"
                  :toggle="toggleArchive">
    </archive-task>
    <edit-task-condensed
      :showDialog="this.showScheduleDialog"
      :toggle="toggleEdit"
    >
    </edit-task-condensed>
    <flag-task
      :showDialog="this.showFlagDialog"
      :toggle="toggleFlag"
     ></flag-task>
  </v-card>
</template>
<script>
import Overview from './tasks/Overview'
import DocumentList from './tasks/DocumentList'
import ImageList from './tasks/ImageList'
import ChangeOrderList from './tasks/ChangeOrderList'
import EditTaskCondensed from '../scheduling/EditCondensed'
import FlagTask from './FlagTask'
import ChecklistCrewDetails from '@/components/workorders/taskManagerTabs/PlanningCrewDetails'
import ArchiveTask from './tasks/Archive'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'DetailView',
  components: {
    Overview,
    DocumentList,
    ImageList,
    ChangeOrderList,
    ChecklistCrewDetails,
    ArchiveTask,
    EditTaskCondensed,
    FlagTask
  },
  data: () => ({
    tab: 'overview',
    crewToAdd: {
      crewId: null,
      taskId: null
    },
    showAddDialog: false,
    showScheduleDialog: false,
    showFlagDialog: false,
    archiveTaskDialog: false,
    taskArchive: {},
    flagDialog: false
  }),
  methods: {
    ...mapActions({
      clearTask: 'workOrderTask/clearTask',
      flagTask: 'workOrderTask/flagTask',
      addCrew: 'workOrderTask/addCrew',
      removeCrew: 'workOrderTask/removeCrew',
      loadDocuments: 'document/loadDocsByTask',
      loadImages: 'image/loadImagesByTask',
      loadChangeOrders: 'changeOrder/loadByTask',
      loadScheduleDaysForTask: 'schedule/loadSchedule'
    }),
    addCrewToTask () {
      if (this.crewToAdd.crewId !== null && this.crewToAdd.taskId !== null) {
        this.addCrew(this.crewToAdd)
        this.showAddDialog = false
      } else {
      }
    },
    toggleEdit() {
      this.loadScheduleDaysForTask
      this.showScheduleDialog = !(this.showScheduleDialog)
    },
    toggleFlag() {
      this.showFlagDialog = !(this.showFlagDialog)
    },
    toggleArchive () {
      this.archiveTaskDialog = !(this.archiveTaskDialog)
    },
    archiveDialogForTask () {
      this.toggleArchive()
    }
  },

  watch: {
    selectedTask (newVal, oldVal) {
      switch (this.tab) {
        case 'documents':
          this.loadDocuments(newVal.id)
          break
        case 'changes':
          this.loadChangeOrders(newVal.id)
          break
        case 'images':
          this.loadImages({ taskId: newVal.id, size: 'small' })
          break
        default:
          break
      }
    }
  },
  computed: {
    ...mapGetters({
      task: 'workOrderTask/selectedTask',
      selectedCrew: 'workOrderTask/selectedCrewTask',
      crews: 'crew/crewsForTasks',
      userRole: 'user/role'
    }),
    getMenuClass() {
      return this.task.flagged !== 'NONE' ? 'flagged-menu-bar' : 'menu-bar'
    },
    selectedTask: {
      get () {
        return this.task
      }
    },
    crewSelected: {
      get () {
        return this.selectedCrew.map(c => {
          return {
            text: (`${this.task.region.name}-${c.crew.name}-${c.crew.crewLead.firstName}`),
            value: c.crew
          }
        })
      },
      set (crew) {
        this.crewToAdd.crewId = crew.id
        this.crewToAdd.taskId = this.task.id
      }
    },
    isDisabled: {
      get() {
        if (this.userRole === 'Sub Foreman') {
            return true
        } else {
            return false
          }
      }
    }
  }
}
</script>
<style scoped>
  .detail-wrapper {
    height: calc(100% - 32px);
    margin: 16px 16px 16px 0;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  .menu-bar {
    background-color: #1e345d;
    color: #ffffff;
  }

  .flagged-menu-bar {
    background-color: #ff5b5b;
    color: #ffffff;
  }

  .wo-number-wrapper {
    height: 52px;
    float: left;
    margin-bottom: 24px;
  }

  .details-actions-wrapper {
    width: 250px;
    height: 44px;
    float: right;
    margin-top: 10px;
  }

  .details-action {
    width: 40px;
    float: right;
    margin-right: 16px;
  }

  .wo-number {
    font-size: 20px;
  }

  .icon-separator:after {
    content: "";
    height: 32px;
    border-left: 1px solid #ffffff;
    margin-top: 14px;
  }

  .close-details {
    float: right;
    margin: 10px 12px 0 16px;
  }

  .v-tabs-bar.v-tabs-bar--is-mobile:not(.v-tabs-bar--show-arrows) > .v-slide-group__wrapper > .v-tabs-bar__content > .v-tab:first-of-type {
    margin-left: 0;
  }

  @media only screen and (max-width: 959px) {
    .detail-wrapper {
      margin: 16px;
    }
  }

  @media only screen and (max-width: 801px) {
    .detail-wrapper {
      padding-top: 8px;
    }

    .wo-number-wrapper {
      margin-bottom: 16px;
    }

    .tab-bar {
      border-bottom: 1px solid #e1e1e1;
    }
  }

  @media only screen and (min-width: 801px) {
    .detail-wrapper {
      overflow-y: scroll;
      overflow-x: hidden;
    }

    .menu-bar,
    .flagged-menu-bar {
      position: sticky;
      top: 0;
      z-index: 3;
    }

    .tab-bar {
      position: sticky;
      top: 76px;
      z-index: 3;
      -webkit-transition-property: opacity, -webkit-box-shadow;
      transition-property: opacity, -webkit-box-shadow;
      transition-property: box-shadow, opacity;
      transition-property: box-shadow, opacity, -webkit-box-shadow;
      -webkit-box-shadow: 0 1px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.12);
      box-shadow: 0 1px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 1px 0 rgba(0, 0, 0, 0.12);
    }
  }

  @media only screen and (max-width: 580px) {
    .crew-lead-phone-header,
    .crew-lead-email-header {
      display: none;
    }
  }

  @media only screen and (max-width: 500px) {
    .wo-number-wrapper {
      width: 225px;
      margin-bottom: 0;
    }

    .details-actions-wrapper {
      width: 100%;
      float: right;
      margin: 8px 0;
    }

    .details-action {
      width: 25%;
      margin: 0;
      text-align: center;
    }

    .icon-separator {
      display: none;
    }

    .close-details {
      margin: 0 8px 0 0;
    }
  }
</style>
